import type { RankingEntry } from '../api/ranking';

interface OvertakeTarget {
  score: number;
  companyName: string;
  nickname: string;
}

export interface RankingTrackerCallbacks {
  onOvertake: (companyName: string, nickname: string) => void;
  onPersonalBest: () => void;
}

// 게임 도중 점수를 받아서 (1) 랭킹 항목을 추월하거나 (2) 자기 최고 기록을
// 처음 넘는 순간을 감지하고 콜백을 발생시킨다.
//
// - 랭킹은 오름차순 정렬 후 가장 낮은 점수부터 비교한다.
// - 자기 베스트는 한 런에서 한 번만 발화한다 (initialHighScore > 0 일 때만).
export class RankingTracker {
  private targets: OvertakeTarget[] = [];
  private pointer = 0;
  private personalBestFired = false;
  private initialHighScore = 0;

  setRankings(entries: ReadonlyArray<RankingEntry>): void {
    this.targets = entries
      .map((entry) => ({
        score: entry.score,
        companyName: entry.companyName,
        nickname: entry.nickname,
      }))
      .sort((a, b) => a.score - b.score);
    this.pointer = 0;
  }

  beginRun(initialHighScore: number): void {
    this.pointer = 0;
    this.personalBestFired = false;
    this.initialHighScore = initialHighScore;
  }

  onScore(currentScore: number, callbacks: RankingTrackerCallbacks): void {
    while (this.pointer < this.targets.length) {
      const next = this.targets[this.pointer];
      if (!next || next.score >= currentScore) break;
      callbacks.onOvertake(next.companyName, next.nickname);
      this.pointer++;
    }
    if (
      !this.personalBestFired &&
      this.initialHighScore > 0 &&
      currentScore > this.initialHighScore
    ) {
      callbacks.onPersonalBest();
      this.personalBestFired = true;
    }
  }
}
